export const version = 'local';



// WEBPACK FOOTER //
// ../src/version.ts